import LockPersonIcon from "@mui/icons-material/LockPerson";
import PublicIcon from "@mui/icons-material/Public";
import { Box, Stack, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";

export const PublicAccessIcon = styled(PublicIcon)(() => ({
  fontSize: 12,
}));

export const RestrictedAccessIcon = styled(LockPersonIcon)(() => ({
  fontSize: 12,
}));

export const SectionTitle = styled(Typography)(({ theme }) => ({
  fontSize: 15,
  fontWeight: 600,
  color: theme.palette.text.secondary,
  marginTop: theme.spacing(2.5),
  marginBottom: theme.spacing(1),
}));

export const PeopleList = styled(Stack)(({ theme }) => ({
  gap: theme.spacing(1.5),
}));

export const PersonRow = styled(Stack)(({ theme }) => ({
  flexDirection: "row",
  alignItems: "center",
  gap: theme.spacing(1.5),
}));

export const PersonMeta = styled(Box)(() => ({
  flex: 1,
  minWidth: 0,
}));

export const Name = styled(Typography)(() => ({
  fontWeight: 500,
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis",
}));

export const Email = styled(Typography)(({ theme }) => ({
  fontSize: 13,
  color: theme.palette.text.secondary,
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis",
}));

export const AccessLevel = styled(Typography)(({ theme }) => ({
  fontSize: 13,
  color: theme.palette.text.secondary,
  textTransform: "capitalize",
  flexShrink: 0,
}));

export const OptionRow = styled(Stack)(({ theme }) => ({
  flexDirection: "row",
  alignItems: "center",
  gap: theme.spacing(1.5),
  minWidth: 0,
}));

export const ComposeArea = styled(Stack)(({ theme }) => ({
  marginTop: theme.spacing(2),
  gap: theme.spacing(1),
}));

export const Footer = styled(Stack)(() => ({
  flexDirection: "row",
  alignItems: "center",
  width: "100%",
}));

export const Spacer = styled(Box)(() => ({
  flex: 1,
}));
